<section class="customer-view-container">
  <db-ecommerce-item-view
    [loading]="loading"
    [pageData]="view"
    [tableHeads]="heads"
    [headerGreedStyle]="headerGreedStyle"
    [showSidebar]="false">
    <ng-container>
      <ng-container *ngIf="orders && orders.length;else emptyTable">
        <section class="order-row"
                 *ngFor="let order of orders"
                 [ngStyle]="headerGreedStyle">
          <div class="order-title row-item ml20">
            <a class="db-link" [routerLink]="'../../../orders/order-view/'+order?.id">#{{order?.id}}</a>
          </div>
          <div class="order-title row-item">
            {{order?.date_created.date| date:'MMM d, h:mm a'}}
          </div>
          <div class="order-price row-item">
            ${{order.total}}
          </div>
          <div class="order-status row-item">
            <span [ngClass]="order.status">{{order.payment_status}}</span>
          </div>
        </section>
      </ng-container>
      <ng-template #emptyTable>
        <div class="empty-table">
          <span>{{'text_customerNoOrder'|dbText}}</span>
        </div>
      </ng-template>
    </ng-container>

  </db-ecommerce-item-view>
</section>
